import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import BFFMLogo from "../../resources/images/logo/BFFM_logo.png";
import WhiteLogo from "../../resources/images/logo/logoonly_white.png";
import AEOMark from "../../resources/images/logo/aeo_mark.png";
import { companycontext } from "../../context/companyinfo";
import { languageStore } from "../../state/language";
import { PrivacyPolicyModal } from "../contents/PrivacyPolicyModal";
import { EmailBlockModal } from "../contents/EmailBlockModal";

const Footer = () => {
  const { language } = languageStore();
  const companyInfo = language === "EN" ? companycontext.en : companycontext.kr;

  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  return (
    <>
      <Div>
        <div className="inner">
          <div className="top">
            <div className="company">
              <div className="brand">
                <Link to="/" className="logo" aria-label="관세법인 에이원 홈">
                  <img src={WhiteLogo} alt="A1" />
                </Link>
              </div>
              <div>
                <strong>{companyInfo.name}</strong>
                {companyInfo.address1 && (
                  <address>
                    {companyInfo.address1}
                    {companyInfo.address2}
                  </address>
                )}
                <div className="contact">
                  <span>T <a href="tel:+82220173300">02-2017-3300</a></span>
                  <span>F 02-2017-3397</span>
                </div>
              </div>
            </div>
            <div className="marks">
              <img
                className="aeo"
                src={AEOMark}
                alt="수출입 안전관리 우수업체(AEO) 공인마크"
                title="수출입 안전관리 우수업체(AEO) 공인"
              />
              <a
                className="badge"
                href="https://easylaw.go.kr/CSP/CnpClsMain.laf?popMenu=ov&csmSeq=1327&ccfNo=3&cciNo=1&cnpClsNo=1&search_put="
                target="_blank"
                rel="noreferrer"
              >
                <img src={BFFMLogo} alt="가족친화우수기업 로고" />
              </a>
            </div>
          </div>
          <div className="bottom">
            <nav>
              <LinkButton onClick={() => setIsPrivacyModalOpen(true)}>
                개인정보처리방침
              </LinkButton>
              <LinkButton onClick={() => setIsEmailModalOpen(true)}>
                이메일무단수집거부
              </LinkButton>
              <a href="/">이용약관</a>
            </nav>
            <small>© AONE Customs &amp; Trade Service. All rights reserved.</small>
          </div>
        </div>
      </Div>

      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />
      <EmailBlockModal
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
      />
    </>
  );
};

export default Footer;

const Div = styled.footer`
  background-color: ${({ theme }) => theme.colors.ink};
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.9rem;
  & > .inner {
    max-width: ${({ theme }) => theme.layout.content};
    margin: 0 auto;
    padding: 3rem clamp(1.25rem, 4vw, 2.5rem) 2rem;
    box-sizing: border-box;
  }
  & .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  & .company {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
    flex-wrap: wrap;
    & .logo > img {
      height: 2.75rem;
    }
    & strong {
      display: block;
      font-size: 1.05rem;
      color: white;
      margin-bottom: 0.4rem;
    }
    & address {
      font-style: normal;
      line-height: 1.7;
    }
    & .contact {
      display: flex;
      gap: 1rem;
      margin-top: 0.2rem;
    }
  }
  & .marks {
    display: flex;
    align-items: center;
    gap: 1rem;
    & img {
      display: block;
      width: 3.75rem;
      opacity: 0.9;
    }
  }
  & .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    padding-top: 1.5rem;
    & > nav {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem 1.5rem;
      & > a,
      & > button {
        color: rgba(255, 255, 255, 0.85);
        &:hover {
          color: white;
          text-decoration: underline;
        }
      }
      & > button:first-child {
        color: white;
        font-weight: 600;
      }
    }
    & > small {
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.45);
      letter-spacing: 0;
    }
  }
  @media (max-width: 575px) {
    & .top {
      flex-direction: column;
    }
  }
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1em;
  padding: 0;
`;
